import spacing from '@/constants/spacing';
import {createThemedStyles} from '@/theme';

const HINT_SIZE = spacing.xs * 1.5;
const EDIT_ICON_SIZE = spacing.l + spacing.xxs;

export const styles = createThemedStyles(theme => ({
  avatarContainer: {
    alignItems: 'center',
    marginTop: spacing.xs,
    marginBottom: -spacing.xs,
  },
  pressed: {
    opacity: 0.6,
  },
  hovered: {
    opacity: 0.8,
  },
  avatarPreviewWrapper: {
    overflow: 'hidden',
    backgroundColor: theme.colors.background,
    borderRadius: theme.box.borderRadius,
  },
  avatarPreview: {
    width: '100%',
    height: '100%',
  },
  avatarEditIcon: {
    position: 'absolute',
    top: -EDIT_ICON_SIZE / 4,
    right: -EDIT_ICON_SIZE / 4,
    width: EDIT_ICON_SIZE,
    height: EDIT_ICON_SIZE,
    borderRadius: EDIT_ICON_SIZE / 2,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.colors.background,
    borderWidth: 1,
    borderColor: theme.colors.borderColor,
    zIndex: 1,
  },
  avatarEditIcon_circular: {
    top: EDIT_ICON_SIZE / 2,
    right: EDIT_ICON_SIZE / 2,
  },
  uploadContainer: {
    flex: 1,
    padding: spacing.m,
    justifyContent: 'center',
  },
  uploadingLabel: {
    position: 'absolute',
    top: -spacing.m,
    alignSelf: 'center',
  },
  uploadProgress: {
    backgroundColor: theme.colors.backgroundDark,
  },
  hintContainer: {
    marginTop: spacing.xs,
    minHeight: HINT_SIZE,
    alignSelf: 'stretch',
  },
}));
